import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import moment from 'moment';

interface ComAndSugg {
  id: string,
  comments: string,
  date: Date,
  dateStr: string,
  type: string,
  checked: boolean,
  user: {
    name: string,
    email: string,
    email2: string,
    sex: string,
    company: string,
    dob: string,
    ocupation: string,
    phone: string,
    profile: {
      downloadURL: string
    }
  }
}
@IonicPage()
@Component({
  selector: 'page-com-and-sugg-detail',
  templateUrl: 'com-and-sugg-detail.html',
})
export class ComAndSuggDetailPage {

  id: string;
  data: ComAndSugg;

  constructor(public navCtrl: NavController, public navParams: NavParams, private fire: AngularFirestore, private modalCtrl: ModalController) {
    this.init();
  }

  init() {
    this.id = this.navParams.get("id");
    if (this.id) {
      this.initDetail(this.id);
    }
  }

  initDetail(id: string) {
    this.fire.doc("complaintsAndSuggestions/" + id).snapshotChanges().subscribe(snap => {
      if (snap.payload.exists) {
        let data = snap.payload.data() as ComAndSugg;
        data.dateStr = moment(data.date ? data.date : new Date()).format("DD MMM YYYY hh:mm:ss a");
        const id = snap.payload.id;
        this.data = { id, ...data };
      }
    }, (error) => {
      console.log(error);
    });
    this.check(id);
  }

  check(id: string) {
    this.fire.doc("complaintsAndSuggestions/" + id).update({ "checked": true })
  }

  ionViewDidLoad() {
  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/com-and-sugg-detail/com-and-sugg-detail.ts